import { render, staticRenderFns } from "./luo.vue?vue&type=template&id=68c23f48&"
import script from "./luo.vue?vue&type=script&lang=js&"
export * from "./luo.vue?vue&type=script&lang=js&"
import style0 from "./luo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports